import RentalTripAdd from "./RentalTripAdd";
import RentalTripAddModal, { RENTAL_TRIP_ADD_MODAL_ID } from "./RentalTripAddModal";

export default RentalTripAdd;

export {
  RentalTripAddModal,
  RENTAL_TRIP_ADD_MODAL_ID,
};
